export class AppSettings {
    static readonly STATIC_REST_ENDPOINT = 'https://sewage-tracking.lantratech.com/sewage-api';
    //static readonly STATIC_REST_ENDPOINT = 'http://localhost:8084';
}